import { createRouter, createWebHistory } from 'vue-router'
import SignInView from '../views/SignInView'
import SignUpView from '../views/SignUpView'
import WearSelect from '../views/WearSelect'
import DataBaseView from '../views/DataBaseView'
import InstructionsView from '../views/InstructionsView'
import InstructionForm from '../views/InstructionForm'
import PageNotFound from '../views/PageNotFound'
import AdminCreateInvite from '../views/AdminCreateInvite'
import AdminInvites from '../views/AdminInvites'
import AdminUsers from '../views/AdminUsers'
import SinglePart from '../views/SinglePart'

import store from '@/store/index.js'

const routes = [
  {
    path: '/',
    name: 'signIn',
    component: SignInView
  },
  {
    path: '/sign-up/:code',
    name: 'signUp',
    component: SignUpView
  },
  {
    path: '/wear-select',
    name: 'WearSelect',
    component: WearSelect,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/db/:db/:table/:subtable',
    name: 'DataBaseView',
    component: DataBaseView,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/instructions/:db/:table/:subtable',
    name: 'InstructionsView',
    component: InstructionsView,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/instruction/:id',
    name: 'InstructionForm',
    component: InstructionForm,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/part/:id',
    name: 'SinglePart',
    component: SinglePart,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/admin/create-invite',
    name: 'AdminCreateInvite',
    component: AdminCreateInvite,
    meta: {
      adminAccessRequired: true
    }
  },
  {
    path: '/admin/invites',
    name: 'AdminInvites',
    component: AdminInvites,
    meta: {
      adminAccessRequired: true
    }
  },
  {
    path: '/admin/users',
    name: 'AdminUsers',
    component: AdminUsers,
    meta: {
      adminAccessRequired: true
    }
  },
  {
    path: '/:pathMatch(.*)*',
    component: PageNotFound
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  if (to.path !== '/' && to.path !== '/wear-select') {
    localStorage.setItem('lastUrl', to.fullPath)
  }
  document.title = 'Admin Panel'
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      if (!store.state.user.role) store.dispatch('ui/getSettings')
      if (!store.state.formula.data) store.dispatch('formula/getFormula')
      next()
      return
    }
    next('/')
  } else if (to.matched.some(record => record.meta.adminAccessRequired)) {
    store.dispatch('ui/getSettings').then(() => {
      if (store.getters.isAdmin) {
        if (!store.state.formula.data) store.dispatch('formula/getFormula')
        next()
      } else if (store.getters.isLoggedIn) {
        if (!store.state.formula.data) store.dispatch('formula/getFormula')
        next('/wear-select')
      } else {
        next('/')
      }
    }).catch(() => {
      next('/')
    })
  } else {
    if (store.getters.isLoggedIn) {
      if (!store.state.formula.data) store.dispatch('formula/getFormula')
      if (localStorage.getItem('lastUrl')) next(localStorage.getItem('lastUrl'))
      else next('/wear-select')
      return
    }
    next()
  }
})

export default router
